export default __webpack_public_path__ + "static/media/hand-left-front.9034b4c0.png";